export type FindDriverEndpointParams = {
  driverPhone: string
  driverName: string
}

export const findDriverEndpoint = (params: FindDriverEndpointParams): string => {
  const query = new URLSearchParams({
    driver_phone: params.driverPhone,
    driver_name: params.driverName,
  })
  return `/berths/bookings/find_driver?${query.toString()}` as const
}
